// src/lib/api/baseUrl.js
const raw = process.env.REACT_APP_BACKEND_URL || "/api";
export const BACKEND_URL = raw.replace(/\/$/, ""); // 끝 / 제거
